<template lang="pug">
v-container(fluid class=" tw-h-full tw-overflow-hidden tw-rounded tw-pt-0 tw-pb-0" style="background: #f5f5fa")
  div(class="tw-flex tw-flex-col tw-h-full  tw-pb-0")
    div(class="tw-flex te-flex-row tw-bg-white tw-w-full tw-rounded-md tw-px-3")
      v-row(justify="end")
        v-col(cols="auto")
          v-btn(depressed color="rgba(94,129,244,0.80)" @click="addContactDialogToggle")
            span(class="tw-font-bold") {{ $t('Contacts.Common.addContact') }}
    div(class="tw-flex tw-flex-row tw-flex-grow tw-overflow-y-auto tw-py-4 tw-bg-white tw-mt-4 tw-rounded-md ")
      v-row(no-gutters justify="space-around" class="fill-height tw-h-full tw-max-h-full tw-overflow-hidden w-100 tw-w-full ")
        v-col(cols="1" md="auto")
          v-row(dense class="tw-pt-2")
            div(class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full pl-2 ")
              div(class="tw-text-sm tw-font-bold tw-text-grey--text text--darken-1 tw-pb-1")
                v-icon(small @click="applyFilter('')") mdi-all-inclusive
              div(v-for="letter in filter" :key="letter" class="tw-cursor-pointer pb-1 pl-0")
                span(@click="applyFilter(letter)") {{ letter }}

        v-col(
          cols="11"
          md="4"
          class="tw-max-h-full tw-h-full tw-overflow-y-scroll tw-overflow-x-hidden pr-2 pr-md-0"
          id="contact-list"
        )
          div(v-if="loading" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full")
            v-progress-circular(indeterminate color="primary" size="64")
          div(v-else class="tw-h-full")
            div(
              v-if="!loading && contactList.length === 0"
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full"
            )
              kubiqa-misc-empty-state(
                :title="$t(selection ? 'Common.emptyStates.filteredContactsTitle' : 'Common.emptyStates.contactsTitle')"
                :description="$t(selection ? 'Common.emptyStates.filteredContactsBody' : 'Common.emptyStates.contactsBody')"
                :action-label="selection ? $t('Common.emptyStates.showAllContacts') : ''"
                icon="mdi-account-multiple-outline"
                @action="applyFilter('')"
              )
            div(v-else class="tw-pb-2")
              div(v-if="selection" class=" tw-w-full tw-bg-gray-lighten-4 tw-py-2 tw-rounded-full tw-text-center")
                span(class="tw-font-bold tw-text-xl") {{ selection }}
              div(v-for="(contact, index) in contactList" :key="contact.id" class="tw-cursor-pointer tw-pt-1")
                kubiqa-contacts-contact-list-item(
                  @click.native="open(contact.id)"
                  :item="contact"
                  action="delete"
                  :ref="'contact-' + contact.id"
                )
                div(v-if="index == contactList.length - 1" v-intersect="paginate" class=" tw-text-center tw-pt-2")
                  v-progress-circular(v-if="paginateLoading" indeterminate color="primary" height="4")

              div(class="tw-pb-2")
        v-col(v-if="!$vuetify.breakpoint.mobile" cols="7")
          v-row(class="fill-height tw-ml-1 tw-pr-4 ")
            v-col(class=" fill-height  tw-mt-1")
              template(v-if="!this.$store.getters['contacts/current_contact']" class="fill-height tw-bg-green-lighten-3")
                v-row(align="center" justify="center" class="fill-height")
                  v-col(cols="auto")
                    div(class=" tw-text-center")
                      v-img(src="@/assets/images/illustrations/contacts-no-selection.svg" width="380px" class="tw-self-center")

              template(v-else)
                kubiqa-contacts-contact-item(:key="mKey")
        template(v-else)
          v-dialog(
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            class="tw-bg-white tw-overflow-hidden"
          )
            v-card(flat background="white" class="tw-bg-indigo-lighten-5 tw-overflow-hidden tw-h-screen")
              div(class="tw-bg-indigo-lighten-5")
                v-row(no-gutters align="center" class="tw-bg-indigo-lighten-5  ")
                  v-col(cols="auto" class="pl-2 pt-1")
                    v-icon(
                      @click="$router.push({ name: 'contacts' }, (dialog = false))"
                      color="grey darken-1"
                      class="tw-cursor-pointer"
                    ) mdi-arrow-left-circle
                  v-col(cols="auto")
                    div(
                      @click="$router.push({ name: 'contacts' }, (dialog = false))"
                      class="tw-capitalize pl-1 tw-cursor-pointer tw-relative"
                    ) {{ $t('Common.back') }}
                v-row(no-gutters class="tw-overflow-hidden mt-n4")
                  v-col(class="tw-overflow-hidden tw-h-screen tw-bg-white my-6 py-2")
                    kubiqa-contacts-contact-item(:key="mKey")

  v-dialog(
    v-model="addContactDialog"
    :fullscreen="$vuetify.breakpoint.mobile ? true : false"
    width="40%"
    max-width="40%"
  )
    div(class="tw-bg-white edit-dialog tw-h-full")
      kubiqa-contacts-edit-main(:key="mKey" :action="'add'" @close="addContactDialogToggle")
</template>
<script>
export default {
  data() {
    return {
      mKey: 1,
      addContactDialog: false,
      loading: false,
      selection: null,
      contactList: [],
      paginateLoading: false,
      // create a variable called filter containing an array with the alphabet
      filter: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ],
    };
  },
  created() {
    this.$store.commit('contacts/SET_CURRENT_CONTACT', null);
    this.$store.commit('displaySidebar', true);
    this.$store.commit('displayWebsiteToolbar', false);
    this.$store.commit('displayMainToolbar', true);
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch('contacts/list').then((response) => {
      this.contactList = response.data;
      this.loading = false;
    });
    if (this.$route.params.id) {
      this.mKey = ++this.mKey;
      this.$store.dispatch('contacts/view', this.$route.params.id).then((response) => {
        this.loading = false;
      });
    }
  },
  computed: {
    contact() {
      return this.$store.getters['contacts/current_contact'];
    },
    id() {
      return this.$route.params.id;
    },
    contacts() {
      return this.$store.getters['contacts/list'];
    },
    dialog: {
      get(val) {
        return this.$route.params.id != null;
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    contact(newContact, oldContact) {
      if (newContact != null) {
        this._.delay(() => {
          this.$vuetify.goTo(this.$refs['contact-' + newContact.id][0], { container: '#contact-list', offset: 300 });
        }, '500');
      }
    },
  },
  methods: {
    applyFilter(letter) {
      //this.$vuetify.goTo('#contact-list', { container: '#contact-list', offset: 300 });
      this.loading = true;
      this.$store.dispatch('contacts/list', letter).then((response) => {
        this.contactList = response.data;
        this.loading = false;
        this.selection = letter;
      });
    },
    open(contact) {
      this.$vuetify.goTo(contact);
      this.$store.dispatch('contacts/view', contact);
      this.$router.push('/contacts/' + contact);
    },
    addContactDialogToggle() {
      this.mKey = ++this.mKey;
      return (this.addContactDialog = !this.addContactDialog);
    },
    paginate(entries) {
      let intersecting = entries[0].isIntersecting;
      if (intersecting && this.contacts.current_page != this.contacts.last_page) {
        this.paginateLoading = true;
        this.$store.dispatch('contacts/paginate', this.contacts.next_page_url).then((response) => {
          this.contactList.push(...response.data);
          this.paginateLoading = false;
        });
      }
    },
  },
};
</script>
